import React from "react";
import UploadGroupBuilder from "../../UploadGroupBuilder/UploadGroupBuilder";
import clsx from "clsx";
import Colorpicker from "../../Colorpicker/Colorpicker";
import I18n from "i18n-js";

export default class PropertyDetailsPresenterGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });
    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div
            className="col-md-12"
            style={{ fontSize: "15px", lineHeight: "21px" }}
          >
            <div style={{ fontWeight: "bold" }}>{this.props.name}</div>
            <div>{this.props.address_1}</div>
            {this.props.address_2 ? <div>{this.props.address_2}</div> : null}
            <div>
              {this.props.city}, {this.props.state}
              {this.props.postal_code ? " " + this.props.postal_code : null}
            </div>
            {this.props.country ? <div>{this.props.country}</div> : null}
          </div>
        </div>
        <hr style={{ marginTop: "15px" }} />
        <div className="row">
          <div className="col-md-8">
            <div className="form-group">
              <UploadGroupBuilder
                upload_type="image"
                upload_type_plural="images"
                dropzone_title={"property_logo"}
                upload_groups={
                  this.props.image_group
                    ? [this.props.image_group]
                    : [{ images: [] }]
                }
                read_only={true}
                helperText={"logo_image_helper_text"}
              />
            </div>
            {this.renderLogoUrls()}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("link_color")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_link_color_helper_text")}
                ></span>
              </label>
              <br />
              <Colorpicker
                read_only={true}
                name="link_color"
                color={this.props.link_color}
              />
            </div>
            <div className="form-group">
              <label>
                {I18n.t("button_background_color")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_button_background_color_helper_text")}
                ></span>
              </label>
              <br />
              <Colorpicker
                read_only={true}
                name="button_background_color"
                color={this.props.button_background_color}
              />
            </div>
            <div className="form-group">
              <label>
                {I18n.t("button_font_color")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_button_font_color_helper_text")}
                ></span>
              </label>
              <br />
              <Colorpicker
                read_only={true}
                name="button_font_color"
                color={this.props.button_font_color}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("address_1")}</label>
              <br />
              {this.props.address_1}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("address_2")}</label>
              <br />
              {this.props.address_2}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("city")}</label>
              <br />
              {this.props.city}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("state_province")}</label>
              <br />
              {this.props.state}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("postal_code")}</label>
              <br />
              {this.props.postal_code}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("country")}</label>
              <br />
              {this.props.country}
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("main_telephone")}</label>
              <br />
              {this.props.main_telephone}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("tollfree_telephone")}</label>
              <br />
              {this.props.tollfree_telephone}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("mobile_telephone")}</label>
              <br />
              {this.props.mobile_telephone}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("fax_telephone")}</label>
              <br />
              {this.props.fax_telephone}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("tdd_telephone")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("tdd_telephone_helper_text")}
                ></span>
              </label>
              <br />
              {this.props.tdd_telephone}
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("email")}</label>
              <br />
              {this.props.email}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("default_from_address")}</label>
              <br />
              {this.props.property.default_from_address}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("default_from_name")}</label>
              <br />
              {this.props.property.default_from_name}
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("website_url")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("website_url_helper_text")}
                ></span>
              </label>
              <br />
              {this.props.website_url}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLogoUrls() {
    if (
      this.props.property.gha_logo_url ||
      this.props.property.tripadvisor_logo_url
    ) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <div
              className="panel panel-default"
              style={{ background: "none", border: "none" }}
            >
              {this.props.property.gha_logo_url ? (
                <div>
                  <a href={this.props.property.gha_logo_url} target="_blank">
                    {I18n.t("gha_logo")}
                  </a>
                </div>
              ) : null}
              {this.props.property.tripadvisor_logo_url ? (
                <div>
                  <a
                    href={this.props.property.tripadvisor_logo_url}
                    target="_blank"
                  >
                    {I18n.t("tripadvisor_logo")}
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
  }
}
